import IconTemplate from '@components/Icon';
import { rem } from 'polished';
import styled from 'styled-components';
import { getMaxPageWidth } from '../../constants';
import { breakpoints } from '../../styles/theme';

export const Background = styled.div`
    background: ${({ theme }) => theme.colors.greyLight};
    width: ${rem(320)};
    padding: 0 ${rem(15)};
    display: flex;
    flex-direction: column;
    background: rgba(116, 120, 129, 0.08);
    border-radius: ${rem(16)};
    margin-bottom: ${rem(20)};
`;

export const Title = styled.div<{ isStaticBanner?: boolean }>`
    font-size: ${({ theme }) => theme.fontSizes.h4};
    font-weight: ${({ theme }) => theme.fontWeights.textBold};
    text-align: center;
    margin-top: ${rem(20)};
    color: ${({ theme }) => theme.colors.black};
    padding: ${rem(10)} ${rem(20)};
`;

export const Price = styled.div<{ isStaticBanner?: boolean }>`
    font-size: ${({ theme }) => theme.fontSizes.h6};
    font-weight: ${({ theme }) => theme.fontWeights.textBold};
    text-align: center;
    margin-top: ${rem(30)};
    color: ${({ theme }) => theme.colors.black};
`;

export const PriceWithVat = styled.div<{ isStaticBanner?: boolean }>`
    font-size: ${({ theme }) => theme.fontSizes.textMedium};
    text-align: center;
    margin-top: ${rem(8)};
    color: ${({ theme }) => theme.colors.black};
`;

export const Section = styled.div<{ isStaticBanner?: boolean }>`
    display: flex;
    flex-direction: column;

    @media (min-width: ${breakpoints.sm}px) {
        flex-direction: ${(prop) => (prop.isStaticBanner ? 'column' : 'row')};
    }
`;

export const Image = styled.img<{ isStaticBanner?: boolean }>`
    width: 40%;
    margin: ${rem(40)} 25% ${rem(40)} 25%;

    @media (min-width: ${breakpoints.sm}px) {
        width: ${rem(200)};
        margin: ${rem(30)} 5% ${rem(30)} 5%;
    }
`;

export const Benefits = styled.div`
    padding: ${rem(20)};
`;

export const BenefitIcon = styled(IconTemplate)`
    svg {
        width: ${rem(25)};
        height: ${rem(25)};
        margin-right: ${rem(10)};

        g polyline {
            stroke: ${({ theme }) => theme.colors.black};
        }
    }
`;

export const Benefit = styled.span`
    display: flex;
    padding-bottom: ${rem(20)};
    line-height: ${rem(24)};
    color: ${({ theme }) => theme.colors.secondaryGrey};

    strong {
        color: ${({ theme }) => theme.colors.black};
    }
`;

export const BenefitLabel = styled.span``;
